import React from "react";
import {
    Dialog,
    DialogContent,
    Box,
    Typography,
    Button,
    styled
} from "@mui/material";
import CloseButton from "../../../Components/CloseButton";

const StyledDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 16,
        boxShadow: theme.shadows[5],
        width: "460px",
        maxWidth: "90%",
        padding: '32px'
    },
}));

const DeleteConfirmationModal = ({ open, onClose, onConfirm, isDeleting }) => {
    return (
        <StyledDialog open={open} onClose={isDeleting ? () => {} : onClose}>
            <DialogContent sx={{ p: 0 }}>
                {/* Close Button */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <CloseButton onClick={onClose} disabled={isDeleting} />
                </Box>

                {/* Header */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2, mt: -2 }}>
                    <Typography
                        variant="fw600s16c000000"
                        sx={{
                            fontSize: '18px',
                            lineHeight: '18px'
                        }}
                    >
                        Attention! Deleting Draft
                    </Typography>
                </Box>

                {/* Message */}
                <Box sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
                    <Typography
                        variant="fw400s16c000000"
                        sx={{
                            textAlign: 'center',
                            color: '#616161',
                            fontSize: '16px',
                            lineHeight: '24px'
                        }}
                    >
                        Are you sure you want to delete this draft?
                    </Typography>
                </Box>

                {/* Action Buttons */}
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                    <Button
                        onClick={onClose}
                        disabled={isDeleting}
                        sx={{
                            borderRadius: '12px',
                            padding: '6px 24px',
                            textTransform: 'none',
                            fontSize: '14px',
                            lineHeight: '22px',
                            fontWeight: 600,
                            color: '#3D4B5A',
                            backgroundColor: '#FFFFFF',
                            border: '1px solid #EBEFF3',
                            '&:hover': {
                                borderColor: '#000000',
                            }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={onConfirm}
                        disabled={isDeleting}
                        sx={{
                            borderRadius: '12px',
                            padding: '6px 24px',
                            textTransform: 'none',
                            fontSize: '14px',
                            lineHeight: '22px',
                            fontWeight: 600,
                            color: '#FFFFFF',
                            backgroundColor: '#6D72F6',
                            '&:hover': {
                                backgroundColor: '#4D44D8',
                            },
                            '&:disabled': {
                                backgroundColor: '#BDBDBD',
                                color: '#FFFFFF',
                            }
                        }}
                    >
                        Confirm
                    </Button>
                </Box>
            </DialogContent>
        </StyledDialog>
    );
};

export default DeleteConfirmationModal;
